import { render, staticRenderFns } from "./weekly-wbs-groups.vue?vue&type=template&id=0a219bc2&scoped=true"
import script from "./weekly-wbs-groups.vue?vue&type=script&lang=js"
export * from "./weekly-wbs-groups.vue?vue&type=script&lang=js"
import style0 from "./weekly-wbs-groups.vue?vue&type=style&index=0&id=0a219bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a219bc2",
  null
  
)

export default component.exports